import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const API = "https://api.m3campus.com";

export default function Inscripcion() {
  const [campus, setCampus] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API}/api/campus/`, { credentials: "include" });
        const data = await res.json();
        setCampus(data);
      } catch (e) {
        console.error(e);
        setCampus([]);
      } finally {
        setLoading(false);  
      }
    })();
  }, []);

  if (loading) return <div style={{ padding: 24 }}>Cargando campus…</div>;

  return (
    <div style={{ padding: 24 }}>
      <h2>Inscripciones a Campus activos</h2>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 16 }}>
        {campus.map((c) => (
          <div
            key={c.id}
            onClick={() => navigate(`/inscripcion/${c.id}`)}
            style={{
              border: "1px solid #eee",
              borderRadius: 12,
              overflow: "hidden",
              cursor: "pointer",
              background: "white",
            }}
          >
            <div style={{ height: 150, background: "#f2f2f2" }}>
              {c.foto ? (
                <img
                  src={c.foto}
                  alt={c.nombre}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              ) : (
                <div style={{ height: "100%", display: "grid", placeItems: "center", color: "#777" }}>
                  Sin foto
                </div>
              )}
            </div>

            <div style={{ padding: 12 }}>
              <div style={{ fontWeight: 700 }}>{c.nombre}</div>
             {c.fecha && (
              <div style={{ marginTop: 6, color: "#666" }}>
                📅 {new Date(c.fecha).toLocaleDateString("es-ES", {
                   day: "numeric",
                   month: "long",
                   year: "numeric",
                      })}
                 </div>
                  )}

                  {c.lugar && (
                      <div style={{ marginTop: 6, color: "#666" }}>
                     📍 {c.lugar}
                       </div>
                          )}

                  {typeof c.plazas_disponibles === "number" && (
                     <div style={{ marginTop: 6, color: "#666" }}>
                       👦 {c.plazas_disponibles} plazas disponibles
                           </div>
                       )}

              <div style={{ marginTop: 10, fontWeight: 700 }}>{c.precio} €</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
